import type { Passkey, PasskeyRepository } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';

export type FindAllPasskeysByUserIdUseCase = UseCase<void, Passkey[]>;

export function findAllPasskeysByUserIdBuilder(
	passkeyRepository: PasskeyRepository
): FindAllPasskeysByUserIdUseCase {
	return async function findAllPasskeysByUserId(): Promise<Passkey[]> {
		return passkeyRepository.findAllPasskeysByUserId();
	};
}
